import type { participation as en } from '@/i18n/locales/en/participation';
import type { Translation } from '@/i18n/types';

export const participation: Translation<typeof en> = {
  page: {
    title: 'Συμμετοχή',
    lead: 'Η χοάνη δέσμευσης: από προσκεκλημένοι έως διαρθρωτικά ενεργοί, συν τα ημερήσια ποσοστά δέσμευσης.',
    noScope: 'Επιλέξτε μια εταιρεία για να δείτε τα στοιχεία συμμετοχής της.',
    noDepartments: 'Κανένα τμήμα εδώ δεν έχει στατιστικά που μπορείτε να δείτε.',
    disclaimer:
      'Όλα τα στοιχεία είναι ενδεικτικές πληροφορίες ευεξίας και δεν αποτελούν ιατρική διάγνωση. Οι τάσεις εμφανίζονται μόνο όταν υπάρχει επαρκής αριθμός συμμετεχόντων (ιδιωτικότητα εκ σχεδιασμού).',
  },
  filters: {
    department: {
      label: 'Τμήμα',
    },
    location: {
      label: 'Τοποθεσία',
      all: 'Όλες οι τοποθεσίες',
    },
  },
  funnel: {
    title: 'Χοάνη δέσμευσης',
    pctOfPrevious: '{{pct}}% του προηγούμενου βήματος',
    steps: {
      invited: 'Προσκεκλημένοι',
      activated: 'Ενεργοποιημένοι',
      active_7d: 'Ενεργοί (7η)',
      active_30d: 'Ενεργοί (30η)',
      structurally_active: 'Διαρθρωτικά ενεργοί',
      needs_reactivation: 'Χρήζουν επανενεργοποίησης',
    },
  },
  rates: {
    title: 'Ποσοστά δέσμευσης',
    keys: {
      daily_sync_pct: 'Ημερήσιος συγχρονισμός',
      ai_coach_use_pct: 'Χρήση προπονητή AI',
      challenge_participation_pct: 'Συμμετοχή σε προκλήσεις',
      notification_open_pct: 'Ανοίγματα ειδοποιήσεων',
      break_adoption_pct: 'Υιοθέτηση διαλειμμάτων',
      focus_rhythm_pct: 'Ρυθμός συγκέντρωσης',
    },
  },
  breakdown: {
    department: 'Ανά τμήμα',
    location: 'Ανά τοποθεσία',
    pilotGroup: 'Ανά πιλοτική ομάδα',
    empty: 'Δεν υπάρχουν ακόμη δεδομένα για ανάλυση.',
    pilotGroupEmpty: 'Κανένα πιλοτικό πρόγραμμα δεν καλύπτει ακόμη αυτό το τμήμα.',
    ratio: '{{activated}}/{{invited}} · {{pct}}%',
    shielded: {
      badge: 'Προστατευμένο',
      message:
        'Ανεπαρκείς συμμετέχοντες ({{invited}}) για ασφαλή προβολή απορρήτου — απαιτούνται τουλάχιστον {{min}}.',
    },
    columns: {
      name: 'Όνομα',
      invited: 'Προσκεκλημένοι',
      activated: 'Ενεργοποιημένοι',
      active30d: 'Ενεργοί (30η)',
    },
  },
  status: {
    noData: '—',
  },
};
